export const DASHBOARD_TRANSLATION_NAMESPACE = "dashboard";

export const DASHBOARD_VIEW_TK = "DASHBOARD_VIEW_TK";
